import {
  SUP_EMPLOYEE_LIST, SUP_EMPLOYEE_LIST_SUCCESS, SUP_EMPLOYEE_LIST_ERROR,
  SUP_EMPLOYEE_PAGE_SET,
  SUP_EMPLOYEE_ADD, SUP_EMPLOYEE_ADD_SUCCESS, SUP_EMPLOYEE_ADD_ERROR,
  SUP_EMPLOYEE_ADD_CHANGE,
  SUP_EMPLOYEE_DETAIL, SUP_EMPLOYEE_DETAIL_SUCCESS, SUP_EMPLOYEE_DETAIL_ERROR,
  SUP_EMPLOYEE_UPDATE, SUP_EMPLOYEE_UPDATE_SUCCESS, SUP_EMPLOYEE_UPDATE_ERROR,
  SUP_EMPLOYEE_FILTER_SUPPLIERS_SUCCESS,
} from '../../actions';

const INIT_STATE = {
  loading: true,
  list: { header: { name: 'id_employee', order: 'sorted-asc' }, page: { current: 1, rows: 1000 }, data: [], total_pages: 1 },
  detail: { loading: false, data: null },
  add: { data: { new: { id_supplier: '', name: '', code: '', email: '', phone: '' } }, loading: false, message: '' },
  edit: { update: { loading: false, response: '', message: '' } },
  filters: { suppliers: [] },
  error: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SUP_EMPLOYEE_LIST: return { ...state, loading: true };
    case SUP_EMPLOYEE_LIST_SUCCESS: return { ...state, loading: false, list: { ...state.list, ...action.payload } };
    case SUP_EMPLOYEE_LIST_ERROR: return { ...state, loading: false, error: true };
    case SUP_EMPLOYEE_PAGE_SET: return { ...state, list: { ...state.list, page: { ...state.list.page, ...action.payload } } };
    case SUP_EMPLOYEE_ADD_CHANGE: return { ...state, add: { ...state.add, data: { ...state.add.data, new: { ...state.add.data.new, ...action.payload } } } };
    case SUP_EMPLOYEE_ADD: return { ...state, add: { ...state.add, loading: true } };
    case SUP_EMPLOYEE_ADD_SUCCESS: return { ...state, add: { ...state.add, loading: false, message: action.payload.message, data: { new: { id_supplier: '', name: '', code: '', email: '', phone: '' } } } };
    case SUP_EMPLOYEE_ADD_ERROR: return { ...state, add: { ...state.add, loading: false, message: action.payload.message } };
    case SUP_EMPLOYEE_DETAIL: return { ...state, detail: { ...state.detail, loading: true } };
    case SUP_EMPLOYEE_DETAIL_SUCCESS: return { ...state, detail: { loading: false, data: action.payload } };
    case SUP_EMPLOYEE_DETAIL_ERROR: return { ...state, detail: { loading: false, data: null } };
    case SUP_EMPLOYEE_UPDATE: return { ...state, edit: { ...state.edit, update: { loading: true, response: '', message: '' } } };
    case SUP_EMPLOYEE_UPDATE_SUCCESS: return { ...state, edit: { ...state.edit, update: { loading: false, response: 'success', message: action.payload } } };
    case SUP_EMPLOYEE_UPDATE_ERROR: return { ...state, edit: { ...state.edit, update: { loading: false, response: 'error', message: action.payload } } };
    case SUP_EMPLOYEE_FILTER_SUPPLIERS_SUCCESS: return { ...state, filters: { ...state.filters, suppliers: action.payload } };
    default: return { ...state };
  }
};
